import { customerColumns } from '../../../Data/Customers/CustomerTrips';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import CommonDataTable from '../../Common/Component/CommonDataTable';
import { getBookingsByCustomer, getTripsByCustomer } from '../../../Services/Customer.service';
import { formatDateString, showAlert } from '../../../Services/Shared.service';
import { Link } from 'react-router-dom';
import CustomizerContext from '../../../_helper/Customizer';
import DataTable from 'react-data-table-component';
import { Spinner } from '../../../AbstractElements';
import ActionOptions from '../../Common/Component/ActionOptions';
import QuickActions from '../../TripManagement/BookingHistory/QuickActions';
import EditBookCab from '../../TripManagement/BookingHistory/EditBookCab';
import AssignDriver from '../../Driver/AssignDriver';
import CancelBooking from '../../TripManagement/BookingHistory/CancelBooking';
import { getBookingById, getCancelReasons } from '../../../Services/Booking.service';
import SharedDataContext from '../../../_helper/SharedData';
const CustomerTripsTable = ({ customerId }) => {
    const [customerData, setCustomerData] = useState([])
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [loader, setLoader] = useState(false)
    const [bookingObj, setBookingObj] = useState({});
    const [assignDriverBookingObj, setAssignDriverBookingObj] = useState({});
    const [editType, setEditType] = useState(null);
    const [editBookCabModal, seteditBookCabModal] = useState(false);
    const toggleBookCabModal = () => seteditBookCabModal(!editBookCabModal);
    const [assignDriverModal, setassignDriverModal] = useState(false);
    const toggleAssignDriverModal = () =>
        setassignDriverModal(!assignDriverModal);

    const [cancelBookingModal, setCancelBookingModal] = useState(false);
    const toggleCancelBookingModal = () =>
        setCancelBookingModal(!cancelBookingModal);
    const [reasonData, setReasonData] = useState([]);

    const { cityData, airportData, setShowApiLoader } = useContext(SharedDataContext);
    const { mix_background_layout } = useContext(CustomizerContext)

    const onChangePage = (page) => {
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    const onClickEditOrRebook = (bookingId, editType) => {
        getBookingById(bookingId)
            .then((bookingRes) => {
                const data = bookingRes.data;
                if (data) {
                    setBookingObj(data);
                    setEditType(editType);
                    toggleBookCabModal();
                }
            })
            .catch((err) => {
                showAlert("error", "Something went wrong");
                setShowApiLoader(false);
            });
    };

    const fetchCustomerBookings = () => {
        setLoader(true)
        const obj = {
            customerId: customerId,
            page: pagination.toString(),
            size: rowsPerPage.toString()
        };

        getBookingsByCustomer(obj)
            .then((result) => {
                setLoader(false)
                if (result.data && result.data.list) {
                    const processData = result.data.list.map((element, index) => {
                        return {
                            booking_number: (
                                <Link
                                    to={element.currentBookingStatusType == "Complete" ? `${process.env.PUBLIC_URL}/trips/trip-info/${element.id}` : `${process.env.PUBLIC_URL}/booking/booking-info/${element.id}`}
                                >
                                    {element.megaCabsBookingNo}
                                </Link>
                            ),
                            pickup_time: element.pickUpDateTime ? formatDateString(element.pickUpDateTime, "MMM DD,YYYY HH:mm") : '-',
                            pickup_location: element.pickUpAddress ? element.pickUpAddress : '-',
                            status: element.currentBookingStatusType ? element.currentBookingStatusType : '-',
                            drop_location: element.destAddress ? element.destAddress : '-',
                            action: (
                                <ActionOptions key={index}>
                                    <QuickActions
                                        setBookingObj={setBookingObj}
                                        element={element}
                                        reasonData={reasonData}
                                        toggleBookCabModal={toggleBookCabModal}
                                        setAssignDriverBookingObj={setAssignDriverBookingObj}
                                        onSubmitData={fetchCustomerBookings}
                                        toggleAssignDriverModal={toggleAssignDriverModal}
                                        toggleCancelBookingModal={toggleCancelBookingModal}
                                        onClickEditOrRebook={onClickEditOrRebook}
                                    />
                                </ActionOptions>
                            ),
                        }
                    });
                    setCustomerData(processData);
                    setPaginationTotalRows(result.data.count);
                }
            })
            .catch((err) => {
                setLoader(false)
                showAlert("error", "Something went wrong");
            });
    };

    useEffect(() => {
        fetchCustomerBookings();
    }, [pagination, rowsPerPage]);

    useEffect(() => {
        getCancelReasons().then((result) => {
            if (result.status == 200 && result.data.length > 0) {
                const data = [];
                result.data.forEach((element) => {
                    if (element.isDeleted) return;
                    data.push({
                        value: element,
                        label: `${element.reason} - ${element.cancelType}`,
                    });
                });
                setReasonData(data);
            }
        });
    }, [])

    return (
        <Fragment>
            <div className="table-responsive customer-trips">
                <DataTable
                    columns={customerColumns}
                    data={customerData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={'50vh'}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    paginationServer
                    pagination
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <EditBookCab
                LargeModaltoggle={toggleBookCabModal}
                title={"Create a new booking"}
                Large={editBookCabModal}
                bookingData={bookingObj}
                cityData={cityData}
                airportData={airportData}
                onSubmitData={fetchCustomerBookings}
                editType={editType}
                setShowApiLoader={setShowApiLoader}
            />

            <AssignDriver
                LargeModaltoggle={toggleAssignDriverModal}
                title={"Assign Driver"}
                Large={assignDriverModal}
                setShowApiLoader={setShowApiLoader}
                assignDriverBookingObj={assignDriverBookingObj}
                onSubmitData={fetchCustomerBookings}
            />
            <CancelBooking
                LargeModaltoggle={toggleCancelBookingModal}
                title={"Trip Cancellation"}
                Large={cancelBookingModal}
                bookingData={bookingObj}
                reasonData={reasonData}
                onSubmitData={fetchCustomerBookings}
                setShowApiLoader={setShowApiLoader}
            />
        </Fragment>
    );
}

export default CustomerTripsTable